export default [
  {
    path: '/attendance/filter/class',
    name: 'PageAttendanceFilterClassDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceFilterClassDetail'
      ),
    meta: { modular: 1, title: '筛选', info: '考勤——筛选班级' }
  },
  {
    path: '/attendance/index',
    name: 'PageAttendanceIndexNew',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceIndexNew'
      ),
    meta: {
      modular: 1,
      title: '学生考勤',
      info: '考勤-首页'
    }
  },
  {
    path: '/attendance/filter',
    name: 'PageAttendanceIndexNewFilter',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceIndexNewFilter'
      ),
    meta: { modular: 1, title: '筛选', info: '考勤-筛选' }
  },
  {
    path: '/attendance/detail/class',
    name: 'PageAttendanceDetailClassNew',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceDetailClassNew'
      ),
    meta: { modular: 1, title: '日打卡详情', info: '考勤——日打卡详情' }
  },
  {
    path: '/attendance/pageAttendanceMonth',
    name: 'PageAttendanceMonth',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceMonth'
      ),
    meta: { modular: 1, title: '月统计', info: '考勤——月统计' }
  },
  {
    path: '/attendance/PageAttendancePeopleCalendar',
    name: 'PageAttendancePeopleCalendar',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendancePeopleCalendar'
      ),
    meta: { modular: 1, title: '打卡月历', info: '考勤——打卡月历' }
  },
  {
    path: '/attendance/pageAttendanceMonthCalendar',
    name: 'PageAttendanceMonthCalendar',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceMonthCalendar'
      ),
    meta: { modular: 1, title: '个人月统计', info: '考勤——个人月统计' }
  },
  {
    path: '/attendance/reports',
    name: 'PageAttendanceReports',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceReports'
      ),
    meta: { modular: 1, title: '导出考勤报表', info: '考勤——导出考勤报表' }
  },
  {
    path: '/attendance/detail/modify',
    name: 'PageAttendanceModify',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceModify'
      ),
    meta: { modular: 1, title: '修改考勤结果', info: '考勤——修改考勤结果' }
  },
  {
    path: '/attendance/notice',
    name: 'PageAttendanceNotice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceNotice'
      ),
    meta: { modular: 1, title: '通知设置', info: '考勤——通知设置' }
  },
  {
    path: '/attendance/noticeDetail',
    name: 'PageAttendanceNoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceNoticeDetail'
      ),
    meta: { modular: 1, title: '自定义通知组', info: '考勤——自定义通知组' }
  },
  {
    path: '/attendance/setting',
    name: 'PageAttendanceSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceSetting'
      ),
    meta: { modular: 1, title: '设置', info: '考勤——设置' }
  },
  {
    path: '/attendance/group',
    name: 'PageAttendanceGroup',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceGroup'
      ),
    meta: { modular: 1, keepAlive: true, title: '考勤组', info: '考勤——考勤组' }
  },
  {
    path: '/attendance/group/memberSelect',
    name: 'PageAttendanceMemberSelect',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceMemberSelect'
      ),
    meta: { modular: 1, title: '参与考勤成员', info: '考勤——参与考勤成员' }
  },
  {
    path: '/attendance/setting/goDownSchool',
    name: 'PageAttendanceGoDownSchool',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceGoDownSchool'
      ),
    meta: { modular: 1, title: '打卡时段', info: '考勤——设置打卡时段' }
  },
  {
    path: '/attendance/setting/inOutSchool',
    name: 'PageAttendanceInOutSchool',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceInOutSchool'
      ),
    meta: { modular: 1, title: '打卡时段', info: '考勤——设置打卡时段' }
  },
  {
    path: '/attendance/setting/createGoDownSchoolTime',
    name: 'PageAttendanceCreateGoDownTime',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceCreateGoDownTime'
      ),
    meta: { modular: 1, title: '打卡时段', info: '考勤——创建上下学打卡时段' }
  },
  {
    path: '/attendance/setting/equipment',
    name: 'PageAttendanceEquipment',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceEquipment'
      ),
    meta: { modular: 1, title: '考勤设备', info: '考勤——考勤设备' }
  },
  {
    path: '/attendance/dorm/equipment',
    name: 'PageAttendanceDormEquipment',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceDormEquipment'
      ),
    meta: {
      modular: 1,
      title: '出入校考勤设备',
      info: '考勤——宿舍出入校考勤设备'
    }
  },
  {
    path: '/attendance/dorm/periods',
    name: 'PageAttendanceEquipmentPeriods',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceEquipmentPeriods'
      ),
    meta: { modular: 1, title: '考勤时段', info: '考勤——宿舍考勤时段' }
  },
  {
    path: '/attendance/dorm/settingDate',
    name: 'PageAttendanceDormDate',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceDormDate'
      ),
    meta: {
      modular: 1,
      title: '设备可用考勤日期',
      info: '考勤——设置宿舍设备可用考勤日期'
    }
  },
  {
    path: '/attendance/setting/settingDate',
    name: 'PageAttendanceSettingDate',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceSettingDate'
      ),
    meta: { modular: 1, title: '考勤日期', info: '考勤——设置考勤日期' }
  },
  {
    path: '/attendance/setting/settingDateRules',
    name: 'PageAttendanceSettingDateRules',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceSettingDateRules'
      ),
    meta: { modular: 1, title: '打卡规则', info: '考勤——设置打卡规则' }
  },
  {
    path: '/attendance/group/save',
    name: 'PageAttendanceGroupSave',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceGroupSave'
      ),
    meta: { modular: 1, title: '创建考勤组', info: '考勤——编辑考勤组' }
  },
  {
    path: '/attendance/dorm/save',
    name: 'PageAttendanceDormSave',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceDormSave'
      ),
    meta: { modular: 1, title: '创建考勤组', info: '考勤——编辑宿舍考勤组' }
  },
  {
    path: '/attendance/moresetting',
    name: 'PageAttendanceMoreSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceMoreSetting'
      ),
    meta: { modular: 1, title: '更多设置', info: '考勤——设置更多' }
  },
  {
    path: '/attendance/setting/specialDate',
    name: 'PageAttendanceSpecialSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceSpecialSetting'
      ),
    meta: {
      modular: 1,
      title: '特殊日期',
      info: '考勤——特殊日期',
      keepAlive: true
    }
  },
  {
    path: '/attendance/setting/specialTimes',
    name: 'PageAttendanceSpecialTimes',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceSpecialTimes'
      ),
    meta: { modular: 1, title: '打卡时段', info: '考勤——特殊打卡时段' }
  },
  {
    path: '/attendance/noattend/students',
    name: 'PageAttendanceNoAttendStudents',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceNoAttendStudents'
      ),
    meta: { modular: 1, title: '未参与考勤学生', info: '考勤——未参与考勤学生' }
  },
  {
    path: '/attendance/setting/joinGroup',
    name: 'PageAttendanceJoinGroup',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/attendance/PageAttendanceJoinGroup'
      ),
    meta: { modular: 1, title: '选择考勤组', info: '考勤——选择考勤组' }
  }
]
